import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await authAPI.forgotPassword(email);
            setSent(true);
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen relative flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
            {/* Background Effects */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-primary-900/10 to-transparent pointer-events-none"></div>
            <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[100px] animate-pulse-glow pointer-events-none" />

            <div className="max-w-md w-full space-y-8 relative z-10 glass p-10 rounded-3xl shadow-2xl">
                <div className="text-center">
                    <Link to="/" className="inline-flex items-center space-x-2 mb-6 group">
                        <img src="/logo-purple.png" alt="AskProdigy.ai" className="h-14 w-auto group-hover:scale-110 transition-transform dark:hidden" />
                        <img src="/logo-white.png" alt="AskProdigy.ai" className="h-14 w-auto group-hover:scale-110 transition-transform hidden dark:block" />
                    </Link>
                    <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-2">
                        {sent ? 'Check your email' : 'Reset your password'}
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        {sent
                            ? "We've sent a password reset link to your email. The link expires in 1 hour."
                            : 'Enter your email address and we will send you a link to reset your password.'}
                    </p>
                </div>

                {error && (
                    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 px-4 py-3 rounded-xl text-sm text-center">
                        {error}
                    </div>
                )}

                {!sent && (
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-1">Email address</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-field"
                                placeholder="you@company.com"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full btn-primary flex justify-center py-3"
                        >
                            {loading ? 'Sending...' : 'Send reset link'}
                        </button>
                    </form>
                )}

                <div className="text-center text-sm">
                    <Link to="/login" className="font-medium text-primary hover:text-primary-600 transition-colors">
                        Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
